import { useRouter } from 'next/router'
import { SyntheticEvent, useEffect, useState } from 'react'

import { MessageDescriptor, useIntl } from 'react-intl'

import { TabContext, TabList } from '@mui/lab'
import { Tab, Theme, useMediaQuery } from '@mui/material'

import Box from 'app/components/base/Box'
import useUserNotifications from 'app/hooks/useUserNotifications'
import useAuthStore, { getAuthUserSlug } from 'app/store/auth.store'
import { STORE_TABS } from 'app/utils/constants/status.constants'
import { getLastUrlSegment } from 'app/utils/helpers/functions.helpers'

import TabNotificationBudge from '~/components/common/TabNotificationBudge'

type StoreTabsProps = {
  tabs: { label: MessageDescriptor; value: string }[]
}

const StoreTabs: RFC<StoreTabsProps> = ({ tabs }) => {
  const { reviewNotifications } = useUserNotifications()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const intl = useIntl()
  const router = useRouter()

  const authUserSlug = useAuthStore(getAuthUserSlug)
  const slug = router.query?.slug
  const isAuthUserStore = authUserSlug === slug

  const defaultValue = getLastUrlSegment(router.pathname)
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue)

    const url = `/store/[slug]/${newValue}`

    router.push({
      pathname: url,
      query: { slug }
    })
  }

  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList
          centered={isMobile}
          onChange={handleChange}
          sx={{
            '& .MuiButtonBase-root': {
              textTransform: 'Capitalize',
              ...(isMobile && { flex: 1 })
            }
          }}
        >
          {tabs.map((tab) => {
            const isCountReviews =
              tab.value === STORE_TABS.reviews &&
              !!reviewNotifications &&
              isAuthUserStore

            return (
              <Tab
                key={tab.value}
                label={
                  <TabNotificationBudge invisible={!isCountReviews}>
                    {intl.formatMessage(tab.label)}
                  </TabNotificationBudge>
                }
                value={tab.value}
              />
            )
          })}
        </TabList>
      </Box>
    </TabContext>
  )
}

export default StoreTabs
